const VATValues = [
    {value: 0, label: "0%"},
    {value: 5, label: "5%"},
    {value: 18, label: "18%"},
    {value: 27, label: "27%"},
];

export default VATValues;
